import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './request/http'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/font/font.css';
import './assets/fonts/iconfont/iconfont.css'
import './assets/fonts/iconfont/iconfontcs.css'
import './element.js'//按需引入elementUI
import MetaInfo from 'vue-meta-info';
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.prototype.$wopen = window.open.bind(window);
function isPhone() {
  return null != navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}
let bln = isPhone();
Vue.prototype.$IsPhone = bln
Vue.prototype.$QueryPath = bln ? "/inqueryM" : '/inquery';
Vue.config.productionTip = false
/**
 * upperFilter
 */
Vue.filter('upperFilter', function (value) {
  // 返回处理后的值
  return value.toUpperCase();
})
Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
